import { Medium, Regular } from '@src/apps/styles/common-style';
import styled from 'styled-components';

export const MainNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px 48px;
  gap: 40px;
  width: 100%;
  height: 74px;
  flex: none;
  order: 0;
  flex-grow: 0;
  background: #f1f4f7;
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  z-index: 10;
`;

/* cntent wrapper */

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 100%;
  height: 40px;
  flex: none;
  order: 0;
  flex-grow: 1;
  justify-content: space-between;

  .responsive-menu-icon {
    display: none;
    width: 40px;
    height: 40px;
    border: 0;
    background: transparent;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    flex: none;
  }

  .responsive-menu-icon span {
    display: block;
    width: 22px;
    height: 2px;
    background: #4b4d4f;
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    justify-content: flex-start;

    .responsive-menu-icon {
      display: inline-flex;
    }
  }
`;

export const UHCInsightsLogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 10px;
  width: 215.05px;
  height: 40px;
  flex: none;
  order: 0;
  flex-grow: 0;

  .line_separator {
    width: 28px;
    height: 28px;
    border: 1px solid #4b4d4f;
    border-radius: 1px;
  }
`;

export const LogoVector = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  height: 40px;
  flex: none;
  order: 0;
  flex-grow: 0;
  .Uhc-logo {
    height: 44px;
    width: 138px;
  }
`;

export const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 2px;
  gap: 8px;
  width: 70px;
  height: 29px;
  flex: none;
  order: 2;
  flex-grow: 0;

  .insights_text {
    width: 66px;
    height: 18px;
    font-family: ${Medium};
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.4px;
    display: flex;
    color: #4b4d4f;
    flex: none;
    order: 0;
    flex-grow: 0;
    position: relative;
    z-index: 1;
  }
`;

/* Frame 24 */

/* _action bar iterations */
export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  height: 40px;
  flex: none;
  order: 1;
  flex-grow: 1;
`;

export const UtilityNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  cursor: pointer;
  min-width: 284px;
  height: 17px;
  flex: none;
  order: 2;
  flex-grow: 0;
  justify-content: flex-end;
`;
export const AiIconStyles = styled.div`
  .help_icon_block {
    display: inline-flex;
    align-items: center;
  }
  .ai_icon {
    margin-right: 13px;
  }
  .help-icon {
    display: inline-flex;
  }
  .ai_icon {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: transparent;
    font: inherit;
    cursor: pointer;
    .ai-tooltip {
      position: absolute;
      left: 50%;
      top: calc(100% + 8px);
      transform: translateX(-50%);
      background: #ffffff;
      color: #000000;
      border: 1px solid #c8cfd6;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
      padding: 15px;
      border-radius: 4px;
      font-family: 'UHCSans-Medium', Helvetica, Arial, Verdana, Tahoma, sans-serif;
      font-size: 12px;
      line-height: 16px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: opacity 120ms ease-in-out, visibility 120ms ease-in-out;
      z-index: 10000;
      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent #ffffff transparent;
        filter: drop-shadow(0 -1px 0 #c8cfd6);
      }
    }
    .ai-tooltip-multiline {
      white-space: normal;
      min-width: 180px;
      span {
        display: block;
      }
    }
    &:hover .ai-tooltip {
      opacity: 1;
      visibility: visible;
    }
    &:focus-visible .ai-tooltip {
      opacity: 1;
      visibility: visible;
    }
    &.tooltip-suppressed .ai-tooltip {
      opacity: 0 !important;
      visibility: hidden !important;
      transition: none !important;
    }
    &:active .ai-tooltip {
      opacity: 0 !important;
      visibility: hidden !important;
      transition: none !important;
    }
  }
`;
export const KnowledgeCenterLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  cursor: pointer;
  min-width: 130px;
  height: 17px;
  flex: none;
  order: 1;
  flex-grow: 0;

  .kc_text {
    height: 17px;
    font-family: ${Regular};
    font-style: normal;
    font-weight: 500;
    font-size: 14.5px;
    line-height: 17px;
    /* identical to box height */
    display: flex;
    align-items: center;
    color: #196ecf;
  }
  .open_in_new_icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const UserInfo = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  min-width: 50px;
  height: 17px;
  flex: none;
  order: 3;
  flex-grow: 0;

  .userinfo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    min-width: 50px;
    height: 17px;
    flex: none;
    order: 0;
    flex-grow: 0;

    &_text {
      height: 17px;
      font-family: ${Regular};
      font-style: normal;
      font-weight: 500;
      font-size: 14.5px;
      line-height: 17px;
      display: flex;
      align-items: center;
      color: #196ecf;
      &:after {
        content: ' ';
        display: block;
        width: 5px;
        height: 1px;
      }

      &::after {
      }
    }

    &_icon {
      width: 16px;
      height: 16px;
      flex: none;
      order: 0;
      display: flex;
      align-items: center;
    }
  }

  .new_tabwrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 4px;
    width: 20px;
    height: 17px;
    flex: none;
    order: 1;
    flex-grow: 0;

    & .open_in_new_icon2 {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0px;
      width: 20px;
      height: 17px;
      flex: none;
      order: 1;
      flex-grow: 0;
      .vector2 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        flex: none;
        order: 1;
        flex-grow: 0;
      }
    }
  }
`;

export const UserInfoBlock = styled.div`
  position: absolute;
  right: 0px;
  top: 30px;
  min-width: 225px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 3px 3px 0 0;
  background-color: #ffffff;
  color: #4b4d4f; /* strom-grey equivalent */
  z-index: 100;

  .sign-out-block {
    border-top: 1px solid #e0e0e0;
    padding: 8px 0px;
  }

  .signout-icon-text {
    padding: 8px 14px;
    display: flex;
    cursor: pointer;

    &:hover {
      background: #e8f3ff !important; /* pattens-blue equivalent */
      color: #2d2d39 !important;

      .signout-text {
        color: #2d2d39 !important;
      }
    }

    &:focus {
      outline: none !important;
    }
  }

  .signout-text {
    color: #4b4d4f; /* strom-grey equivalent */
    font-family: 'UHCSans-Medium', Helvetica, Arial, Verdana, Tahoma, sans-serif;
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 22px;
  }

  p {
    margin: 0;
  }

  .profile-details-block {
    padding: 16px;
    .profile-name {
      color: $black-rock;
      font-family: 'UHCSans-Medium', Helvetica, Arial, Verdana, Tahoma, sans-serif;
      font-size: 16px;
      letter-spacing: 0.2px;
      line-height: 22px;
    }
    .profile-mail,
    .profile-id {
      color: $strom-grey;
      font-family: 'UHCSans-Regular', Helvetica, Arial, Verdana, Tahoma, sans-serif;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.2px;
      line-height: 18px;
    }
  }
  .profile-block-border-bottom {
    border-bottom: 1px solid $gainsboro;
  }

  .user-sectB {
    border-top: 1px solid #e0e0e0;
    padding: 10px 0px;

    .signout {
      padding: 8px 14px;
      &:hover {
        background-color: #f1f4f7;

        .signout-background .signout-text {
          color: #000000;
        }

        .signout-background .signout-btn svg {
          fill: #000000;
        }
      }

      .signout-background {
        display: flex;
        cursor: pointer;

        .signout-btn {
          margin-top: 3px;
        }
        .signout-text {
          font-size: 16px;
          color: #757588;
          font-family: ${Medium};
          padding-left: 8px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
`;
